export const QUESTIONNAIRE_KEY = 'questionnaire';
export const PATHS = {
  QUESTIONNAIRE_LIST: '/questionnaire-list',
  QUESTIONNAIRE_BUILDER: ':questionnaireId',
};
